module.exports = __webpack_public_path__ + "media/images/new_culture/bg-8-orange-e8a369c93d2e93cdbbc935281088eaa2.png";